import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { EmotionTheme } from 'src/domains/layouts/state/environmentState/EnvironmentState';
import { withConfig } from 'src/withConfig';

const setRaceMetaData = (nextRacesNew: boolean): SerializedStyles => {
    if (nextRacesNew) {
        return css`
            &::after {
                content: '•';
                margin: 0 8px;
            }
            &:nth-last-of-type(2) {
                &::after {
                    content: none;
                }
            }
        `;
    }
    return css`
        &::after {
            background: currentcolor;
            content: '';
            display: inline-block;
            height: calc(12px / 1.33); /* fontSize.small / 1.33 */
            margin: 0 8px;
            width: 1px;
        }
    `;
};

interface RaceMetaDataPropsType {
    nextRacesNew: boolean;
}

export const RaceMetaData = styled('div', { label: 'RaceMetaData' })<RaceMetaDataPropsType>`
    font-style: normal;
    position: relative;
    ${({ nextRacesNew }): SerializedStyles => setRaceMetaData(nextRacesNew)};
    &:last-of-type {
        &::after {
            content: none;
        }
    }
`;

export const RaceMetaDataWeather = styled('div', { label: 'RaceMetaDataWeather' })`
    font-style: normal;
    position: relative;
    &::after {
        content: '•';
        margin: 0 8px;
    }
    &:nth-last-of-type(2) {
        &::after {
            content: none;
        }
    }
    &:last-of-type {
        &::after {
            content: none;
        }
    }
`;

export const RaceMetaDataHandicap = styled(RaceMetaData, { label: 'RaceMetaDataHandicap' })`
    margin-right: 4px;
    &::after {
        content: none;
    }
`;

const setRaceMetaDataEw = (nextRacesNew: boolean, theme: EmotionTheme): SerializedStyles => {
    if (nextRacesNew) {
        return css`
            background: ${theme.star.raceCardDetails.bgColor};
            border-radius: 4px;
            margin: 16px 0 0;
            padding: 8px;
            width: 100%;
        `;
    }
    return css``;
};

export const RaceMetaDataEw = withConfig(theme => styled(RaceMetaData, { label: 'RaceMetaDataEw' })`
    ${({ nextRacesNew }): SerializedStyles => setRaceMetaDataEw(nextRacesNew, theme)};
    &:only-of-type {
        margin-top: 0;
    }
    &:empty {
        display: none;
    }
`);
